import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";

function ViewOrderModal(props) {
  const { setIsOpenModal, isOpenModal, selectedData, setSelectedData } = props;
  const ImageUrl = useSelector((state) => state.AuthReducer.imageUrl);
  return (
    <>
      <Modal
        isOpen={isOpenModal}
        toggle={() => {
          setIsOpenModal(false);
        }}
        className="custom-modal modal-width orderView-Modal"
      >
        <FontAwesomeIcon
          icon={faTimesCircle}
          className="modal-close"
          onClick={() => setIsOpenModal(false)}
        />
        <h2 style={{ textAlign: "center" }}>Order Details</h2>
        <table>
          <thead>
            <tr className="topbar">
              <th></th>
              <th className="productDetail">Product Name</th>
              <th className="Proprice">Amount</th>
              <th className="productDetail">OrderNo</th>
              <th className="productDetail">Status</th>
            </tr>
          </thead>

          <tbody>
            {selectedData?.details?.map((item, index) => {
              console.log(item);
              return (
                <tr className="products modal-padding" key={index}>
                  <td className="Proprice">
                    <figure className="modal-productImg">
                      <img
                        src={`${ImageUrl?.product_thumbnail_url}/${item?.product?.thumbnail}`}
                        alt=""
                        className="image-fluid image-width"
                      />
                    </figure>
                  </td>
                  <td className="productDetail">
                    <div className="product-detail-modal">
                      <div className="name">
                       
                        <p className="font-13">{item?.product?.name}</p>
                      </div>
                    </div>
                  </td>
                  <td className="name">
                    <p className="font-13"> {item?.price}</p>
                  </td>
                  <td className="name">
                    <p className="font-13">{item?.order_id}</p>
                  </td>
                  <td className="Proprice">
                    <p className="font-13"> {item?.delivery_status}</p>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Modal>
    </>
  );
}

export default ViewOrderModal;
